/** API route map: URLS.Controller.CreateAccount */
// EN-26599 — Create Account (username-based signup). Backend not built yet;
// update these route names to match the real controller once the API is delivered.
export const CreateAccount = {
      Name: 'CreateAccount/',
      // EN-26599 — the submit EDITS the existing user/employee rows resolved from the token.
      EditUser: 'edit-user',
      CheckUsernameAvailability: 'check-username-availability',
      GetEmployeeDataByToken: 'get-employee-data',
      // EN-32350 — legacy user's "Set Username and Password" submit from the emailed link.
      SetLegacyUsername: 'set-legacy-username',
};
